import styled from 'styled-components'

import {
  PurpleColorL,
  PurpleColorXS,
  RedColor,
  WhiteColor,
  WhiteColorM
} from '../../../../assets/styles/colors'

export const InputContainer = styled.input`
  width: 100%;
  background-color: ${WhiteColorM};
  line-height: 21px;
  font-size: 14px;
  color: ${PurpleColorL};
  border-radius: 10px;

  ${props => {
    switch (props.hasError) {
      case true: return `border: 2px solid ${RedColor};`
      default: return `border: 2px solid ${PurpleColorXS};`
    }
  }}

  &:placeholder-shown {
    background-color: ${WhiteColor};
    color: #D5D8DE;
  }

  &::placeholder {
    color: #D5D8DE;
  }

  ${props => {
    switch (props.type) {
      case 'file': return `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        cursor: pointer;
      `
      default: return ''
    }
  }}

  ${props => {
    switch (props.disabled) {
      case true: return 'cursor: default;'
      default: return ''
    }
  }}

  @media (min-width: 1200px) {
    padding: 20px 25px;
  }

  @media (min-width: 767px) and (max-width: 1199px) {
    padding: 10px 15px;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 8px 10px;
  }
`
